import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const ViewTeacher = () => {
  const { id } = useParams();
const [teacher, setTeacher] = useState({});

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

useEffect(() => {
  if (!id) return;

  const sessionId = localStorage.getItem("currentSessionId");

  if (!sessionId) {
    setError("Session not found. Please re-login.");
    setLoading(false);
    return;
  }

  const fetchTeacher = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${id}`,
        {
          params: { sessionId },
        }
      );

      setTeacher(response.data);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  fetchTeacher();
}, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

const excludedKeys = [
  '_id',
  '__v',
  'password',
  'permissions',
  'image',
  'Image',
  'profileImage'
];



  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
     <h1 className="text-3xl font-bold mb-6 text-center">Teacher Profile</h1>
<hr />

{/* ⭐ PROFILE IMAGE TOP */}
<div className="flex justify-center mt-6 mb-6">
  {teacher.image || teacher.Image || teacher.profileImage ? (
    <img
      src={teacher.image || teacher.Image || teacher.profileImage}
      alt="Teacher"
      className="w-40 h-40 object-cover rounded-full border-4 border-blue-500 shadow-lg"
    />
  ) : (
    <div className="w-40 h-40 rounded-full bg-gray-200 flex items-center justify-center">
      No Image
    </div>
  )}
</div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        {Object.keys(teacher)
  .filter((key) => !excludedKeys.includes(key))
  .map((key) => (
    <div key={key} className="bg-gray-100 p-4 rounded-lg shadow-md">
      <strong className="block text-gray-700">
        {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}:
      </strong>

      <div className="text-gray-900 mt-2">

        {/* 🖼 PROFILE IMAGE */}
        {key.toLowerCase().includes("image") && teacher[key] ? (
          <img
            src={teacher[key]}
            alt="profile"
            className="w-32 h-32 object-cover rounded-lg border shadow"
          />
        )

        /* 📅 DATE FORMAT */
        : key === 'dateOfBirth' || key === 'joiningDate' ? (
          new Date(teacher[key]).toLocaleDateString()
        )

        /* 📄 DOCUMENT LINKS */
        : key === 'tenthDmc' || key === 'plusTwoDmc' || key === 'graduation' || key === 'masters' || key === 'diploma' ? (
          teacher[key] ? (
            <a href={teacher[key]} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
              View Document
            </a>
          ) : "No document"
        )

        /* 🔤 NORMAL TEXT */
        : (
          teacher[key]
        )}
      </div>
    </div>
))}

      </div>
    </div>
  );
};

export default ViewTeacher;
